import classNames from "classnames";
import contactUsIcon from "../../../../assets/icons/contact_us.svg";
import classes from "./ContactUs.module.css";

const ContactUs = () => {
  return (
    <div
      className={classNames(
        "flex items-center justify-between",
        classes["contact-us"]
      )}
    >
      <h2 className={classes["contact-us__header"]}>تواصل معنا</h2>
      <div
        className={classNames(
          "flex items-center",
          classes["contact-us__phone"]
        )}
      >
        <p className={classes["contact-us__text"]}>
          اتصل بنا على
          <br />
          <a
            href="tel:17110"
            className={classNames(
              "numeric-content",
              classes["contact-us__phone-link"]
            )}
          >
            17110
          </a>
        </p>
        <img src={contactUsIcon} alt="contact us" />
      </div>
    </div>
  );
};

export default ContactUs;
